module.exports = __webpack_public_path__ + "static/media/09.582f597e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/verdindung/09.png
// module id = 125
// module chunks = 0